import React, { Component } from 'react'

class Timepoint extends React.Component{
  render() {
    return (
      <article className="timeline-entry animate-box" data-animate-effect="fadeInTop">
      <div className="timeline-entry-inner">
          <div className={"timeline-icon color-".concat(this.props.color)}>
          <i className={this.props.icon} />
        </div>
        <div className="timeline-label">
            <h2>{this.props.title}<span>&nbsp; &nbsp; {this.props.time}</span></h2>
          <p>{this.props.content}</p>
        </div>
      </div>
    </article>
    )
  }
}

export default class Timeline extends Component {
  render() {
    return (
      <div>
        <section className="colorlib-experience" data-section="Timeline">
          <div className="colorlib-narrow-content">
            <div className="row">
              <div className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box" data-animate-effect="fadeInLeft">
                <span className="heading-meta">Timeline</span>
                <h2 className="colorlib-heading animate-box">My Experience</h2>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="timeline-centered">
                  <Timepoint title="PhD student at Washington University in St. Louis" time="August 2024-present" content="" color="1" icon="icon-pen2"></Timepoint>
                  <Timepoint title="Visiting student at Washington University in St. Louis" time="August 2023-June 2024" content="" color="2" icon="icon-pen2"></Timepoint>
                  <Timepoint title="Summer student in IDG/McGovern institute at Tsinghua University" time="July 2022-May 2023" content="" color="3" icon="icon-pen2"></Timepoint>
                  <Timepoint title="Undergraduate student at Zhejiang University" time="August 2019-July 2023" content="" color="4" icon="icon-pen2"></Timepoint>
                  {/* <Timepoint title="Secondary education" time="August 2013-June 2019" content="" color="3" icon="icon-pen2"></Timepoint> */}

                  <article className="timeline-entry begin animate-box" data-animate-effect="fadeInBottom">
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-none">
                      </div>
                    </div>
                  </article>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    )
  }
}
